import { usePageTitle } from "./hooks/usePageTitle";

function PrivacyPolicy() {
  usePageTitle('Privacy Policy')
  return (
    <div
      id="ts-privacy-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-privacy-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Privacy Policy
        </div>

        <div className="w-full text-normal flex flex-col items-start justify-start p-2 space-y-4">
          <span>
            Please also read our{' '}
            <a className="text-light-text-link" href="/privacy/terms-of-use">
              Terms of Use
            </a>{' '}
            for this website.
          </span>


          TerraSciences Ltd. is committed to protecting your privacy and
          developing technology that gives you the most powerful and safe online
          experience. This Statement of Privacy applies to the TerraSciences
          Ltd. web site and governs data collection and usage. By using the
          TerraSciences Ltd. website, you consent to the data practices
          described in this statement. Collection of your Personal Information
          <br /> <br />
          TerraSciences Ltd. collects personally identifiable information, such
          as your e-mail address, name, home or work address or telephone
          number. TerraSciences Ltd. may also collects anonymous demographic
          information, which is not unique to you, such as your ZIP code, age,
          gender, preferences, interests and favorites.
          <br />
          <br />
          There is also information about your computer hardware and software
          that is automatically collected by TerraSciences Ltd. This information
          can include: your IP address, browser type, domain names, access times
          and referring web site addresses. This information is used by
          TerraSciences Ltd. for the operation of the service, to maintain
          quality of the service, and to provide general statistics regarding
          use of the TerraSciences Ltd. web site.
          <br />
          <br />
          Please keep in mind that if you directly disclose personally
          identifiable information or personally sensitive data through
          TerraSciences Ltd. public message boards, this information may be
          collected and used by others. Note: TerraSciences Ltd. does not read
          any of your private online communications.
          <br />
          <br />
          TerraSciences Ltd. encourages you to review the privacy statements of
          web sites you choose to link to from TerraSciences Ltd. so that you
          can understand how those web sites collect, use and share your
          information. TerraSciences Ltd. is not responsible for the privacy
          statements or other content on web sites outside of the TerraSciences
          Ltd. and TerraSciences Ltd. family of Web sites.
          <br />
          <br />
          Use of your Personal Information
          <br />
          TerraSciences Ltd. collects and uses your personal information to
          operate the TerraSciences Ltd. web site and deliver the services you
          have requested. TerraSciences Ltd. also uses your personally
          identifiable information to inform you of other products or services
          available from TerraSciences Ltd. and its affiliates. TerraSciences
          Ltd. may also contact you via surveys to conduct research about your
          opinion of current services or of potential new services that may be
          offered.
          <br />
          <br />
          TerraSciences Ltd. does not sell, rent or lease its customer lists to
          third parties. TerraSciences Ltd. may, from time to time, contact you
          on behalf of external business partners about a particular offering
          that may be of interest to you. In those cases, your unique personally
          identifiable information (e-mail, name, address, telephone number) is
          not transferred to the third party. In addition, TerraSciences Ltd.
          may share data with trusted partners to help us perform statistical
          analysis, send you email or postal mail, provide customer support, or
          arrange for deliveries. All such third parties are prohibited from
          using your personal information except to provide these services to
          TerraSciences Ltd., and they are required to maintain the
          confidentiality of your information.
          <br />
          <br />
          TerraSciences Ltd. does not request or use or disclose sensitive
          personal information, such as race, religion, or political
          affiliations, without your explicit consent.
          <br />
          <br />
          TerraSciences Ltd. keeps track of the web sites and pages our
          customers visit within TerraSciences Ltd., in order to determine what
          TerraSciences Ltd. services are the most popular. This data is used to
          deliver customized content and advertising within TerraSciences Ltd.
          to customers whose behavior indicates that they are interested in a
          particular subject area.
          <br />
          <br />
          TerraSciences Ltd. web sites will disclose your personal information,
          without notice, only if required to do so by law or in the good faith
          belief that such action is necessary to: (a) conform to the edicts of
          the law or comply with legal process served on TerraSciences Ltd. or
          the site; (b) protect and defend the rights or property of
          TerraSciences Ltd.; and, (c) act under exigent circumstances to
          protect the personal safety of users of TerraSciences Ltd., or the
          public.
          <br />
          <br />
          Use of Cookies
          <br />
          The TerraSciences Ltd. web site uses "cookies" to help you personalize
          your online experience. A cookie is a text file that is placed on your
          hard disk by a web page server. Cookies cannot be used to run programs
          or deliver viruses to your computer. Cookies are uniquely assigned to
          you, and can only be read by a web server in the domain that issued
          the cookie to you.
          <br />
          <br />
          One of the primary purposes of cookies is to provide a convenience
          feature to save you time. The purpose of a cookie is to tell the web
          server that you have returned to a specific page. For example, if you
          personalize TerraSciences Ltd. pages, or register with TerraSciences
          Ltd. site or services, a cookie helps TerraSciences Ltd. to recall
          your specific information on subsequent visits. This simplifies the
          process of recording your personal information, such as billing
          addresses, shipping addresses, and so on. When you return to the same
          TerraSciences Ltd. web site, the information you previously provided
          can be retrieved, so you can easily use the TerraSciences Ltd.
          features that you customized.
          <br />
          <br />
          You have the ability to accept or decline cookies. Most Web browsers
          automatically accept cookies, but you can usually modify your browser
          setting to decline cookies if you prefer. If you choose to decline
          cookies, you may not be able to fully experience the interactive
          features of the TerraSciences Ltd. services or Web sites you visit.
          <br />
          <br />
          Changes to this Statement
          <br />
          TerraSciences Ltd. will occasionally update this Statement of Privacy
          to reflect company and customer feedback. TerraSciences Ltd.
          encourages you to periodically review this Statement to be informed of
          how TerraSciences Ltd. is protecting your information.
          <br />
          <br />
          Contact Information
          <br />
          TerraSciences Ltd. welcomes your comments regarding this Statement of
          Privacy. If you believe that TerraSciences Ltd. has not adhered to
          this Statement, please contact TerraSciences Ltd. Registered users
          should use the support email address, all others should use the
          “Contact us” form from the menu.
          <br />
          <br />
          TerraSciences Ltd. will use commercially reasonable efforts to
          promptly determine and remedy the problem.
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
